import { Component, EventEmitter, Input, Output } from "@angular/core";
import { WorkOrder } from "../../model";
import { ActionListWidgetV2Service } from "./action-list-widget-v2.service";

@Component({
    selector: 'work-order-list',
    template: require('./work-order-list.component.html'),
    styles: [`
        .work-order-container {
            background-color: var(--sn-surface-2, #F5F5F5);
            color:var(--sn-surface-2-on, inherit);
            border-radius: 4px;
            padding: 16px;
            margin-bottom: 16px;
            gap: 24px;
        }
    `],
    providers: [ActionListWidgetV2Service]
})
export class WorkOrderListComponent {

    @Input() workOrders: WorkOrder[];

    @Input() writePermission: boolean;

    @Input() showCreateButton: boolean;

    @Output() createWorkOrder = new EventEmitter<void>();

    @Output() selectWorkOrder = new EventEmitter<WorkOrder>();

    @Output() openHistory = new EventEmitter<void>();

}